import React from 'react'
import {
  Container,
  Header,
} from 'semantic-ui-react'

const NoMatch = ({ location }) => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>Unknown URL</Header>
    <p>
      No match for <code>{location.pathname}</code>
    </p>
  </Container>
);

export default NoMatch
